
import { computed, defineComponent, PropType, ref } from 'vue'
import { weatherData as wd } from "../interfaces/weatherI"
import Draggable from "vuedraggable";


export default defineComponent({
  name: "WidgetSettings",
  components: {
      Draggable
  },

  props: {
      cities: {
          type: Array as PropType<Array<wd>> | undefined,
          require: true,
          default: null
      }
  },

  emits: ["showWidgetSettings", "removeCity", "addCity", "dragCities"],

  setup(props, {emit}) {
    const cityAdded = ref("")

    const getIconSrc = (iconCode: string) => `http://openweathermap.org/img/wn/${iconCode}@2x.png`

    const emitCityName = () => {
      emit('addCity', cityAdded.value)
      cityAdded.value = ""
    }

    const getCities = computed({
      get: () => props.cities,
      set: (val) => {
        window.localStorage.setItem("wData", JSON.stringify(val))
        emit("dragCities", val)
      }
    })


    return {
      getCities,
      cityAdded,
      getIconSrc,
      emitCityName
    }
  }

})
